import './styles/SubscriptionScreen.css';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSubscriber } from '../../../apiservices/LocalStorageService';
import { createSubscription } from '../../../apiservices/axiosservice/subscriberservice';

const SubscriptionScreen: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { categories } = location.state || {};
  const subscriber = getSubscriber();

  const handleCreateSubscription = async (plan: string) => {
    const subRequest: subscriptionRequest = {
      subscriptionPlan: plan,
      userId: subscriber.userId,
      interestedSectorIds: categories,
    };
    try {
      const response = await createSubscription(subRequest);
      if (response.data && response.data.profiled) navigate('/dashboard/home');
    } catch (error) {}
  };

  const plans = [
    {
      name: 'Free',
      price: '$0',
      period: '',
      highlighted: false,
      features: [
        'Up to 5 quizzes per month',
        'Up to 10 participants',
        'Basic analytics',
        'Email support',
      ],
    },
    {
      name: 'Pro',
      price: '£5',
      period: '/month',
      highlighted: true,
      disabled: true,
      features: [
        'Unlimited quizzes',
        'Unlimited participants',
        'Advanced analytics & reports',
        'Priority support',
        'Custom branding',
        'AI quiz generation',
      ],
    },
  ];

  return (
    <div className="sub-page">
      <div className="sub-wrapper">
        <div className="sub-header">
          <span className="sub-icon">😊</span>
          <h1>Choose your plan</h1>
          <p>Start free, upgrade when you're ready to do more</p>
        </div>

        <div className="sub-plans">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`sub-plan-card ${plan.highlighted ? 'highlighted' : ''} ${plan.disabled ? 'sub-plan-card--disabled' : ''}`}
            >
              {plan.disabled && <span className="sub-plan-badge">Coming Soon</span>}
              <div className="sub-plan-header">
                <h2>{plan.name}</h2>
                <div className="sub-plan-price">
                  <span className="sub-price-amount">{plan.price}</span>
                  {plan.period && <span className="sub-price-period">{plan.period}</span>}
                </div>
              </div>
              <ul className="sub-plan-features">
                {plan.features.map((feature, i) => (
                  <li key={i}>
                    <span className="sub-check">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <button
                className={`sub-plan-btn ${plan.highlighted ? 'btn-highlighted' : ''}`}
                onClick={() => handleCreateSubscription(plan.name)}
                disabled={plan.disabled}
              >
                {plan.highlighted ? 'Get Pro' : 'Get started for free'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionScreen;
